import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const NovasLojas = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Defina a largura que considera como mobile
    };

    handleResize(); // Chama na inicialização
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleClick = () => {
    // Rastreando o evento no Google Analytics
    if (window.gtag) {
      window.gtag('event', 'banner_terca_dobro', {
        event_category: 'Banner',
        event_label: 'terca dobro Banner',
        value: 1,
      });
    }
  };

  const imageUrl = isMobile 
    ? "/img/banner/banner_em_breve-mobile.png" // URL da imagem mobile
    : "/img/banner/banner_em_breve-desktop.png"; // URL da imagem desktop

  return (
    <Link to='https://pizzaprime.voceqpad.com.br' target='_blank' onClick={handleClick}>
      <img src={imageUrl} alt="Pizza Prime" style={{ width: '100%', height: 'auto' }} />
    </Link>
  );
};

export default NovasLojas;
